import {JsonAdapter} from "../helpers/JsonAdapter";
import {Vacancy} from "./Vacancy";
import {EnvironmentService} from "../services/environment.service";
import {IndividualProfile} from "./IndividualProfile";

export class View {
  id: string = "";
  vacancy!: Vacancy;
  organisation_name?: string = "";
  user_profile?: IndividualProfile;
  created_at: string = "";
  job_title: string = "";
  count = 0;

  static create(object:any, env: EnvironmentService | null = null): View {
    const item = JsonAdapter.fill(new View(), object);
    if(object.vacancy) {
      item.vacancy = Vacancy.create(object.vacancy, env);
    }

    if(object.user_profile) {
      item.user_profile = IndividualProfile.create(object.user_profile);
    }
    return item;
  }
  static createMultiple(objects: View[]): View[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(View.create(objects[i]));
    }
    return items;
  }
}
